export type PeelPoint={x:number;y:number};
export function curlPoint(p:PeelPoint,width:number,height:number,progress:number,direction:PeelPoint){
  const length=Math.hypot(direction.x,direction.y)||1,n={x:direction.x/length,y:direction.y/length};
  const projections=[0,width*n.x,height*n.y,width*n.x+height*n.y],low=Math.min(...projections),high=Math.max(...projections);
  const radius=Math.max(1,Math.min(width,height)*.19),limit=2.72,crease=high-(high-low+radius*limit)*Math.max(0,Math.min(1,progress));
  const distance=Math.max(0,p.x*n.x+p.y*n.y-crease),angle=Math.min(limit,distance/radius),tail=Math.max(0,distance-radius*limit);
  const displacement=radius*Math.sin(angle)+tail*Math.cos(angle)-distance;
  return{x:p.x+n.x*displacement,y:p.y+n.y*displacement,z:radius*(1-Math.cos(angle))+tail*Math.sin(angle),angle};
}
export function anchoredCurl(p:PeelPoint,anchor:PeelPoint,width:number,height:number,progress:number,direction:PeelPoint){
  const bent=curlPoint(p,width,height,progress,direction),grab=curlPoint(anchor,width,height,progress,direction);
  return{...bent,x:bent.x-grab.x+anchor.x,y:bent.y-grab.y+anchor.y};
}
